<script setup lang="ts">
import { Head } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'

import { Fieldset } from 'primevue'
import Chart from 'primevue/chart'
import { onMounted, ref } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faInfoCircle } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faInfoCircle)

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    stats: { name: string, value: number, unit?: string }[]
    stats_pie: {
        labels: string[]
        datasets: {
            label: string
            data: number[]
            backgroundColor: string[]
        }[]
    }
}>()

const setChartOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement)
    const textColor = documentStyle.getPropertyValue('--p-text-color')

    return {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    color: textColor
                }
            }
        }
    };
};
const chartOptions = ref()
onMounted(() => {
    chartOptions.value = setChartOptions()
})
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />
    <div class="mt-6 w-full mx-auto max-w-7xl grid md:grid-cols-2 gap-px gap-x-2 gap-y-4 px-4 py-3">
        <div class="grid grid-cols-2 gap-x-2 gap-y-2 h-fit">
            <div v-for="stat in stats" :key="stat.name" class="first:bg-cyan-100 first:text-cyan-700 first:border first:border-cyan-300 bg-gray-100 px-4 py-6 sm:px-6 lg:px-8 rounded border border-gray-300">
                <p class="text-sm font-medium opacity-60">
                    {{ stat.name }}
                    <FontAwesomeIcon v-if="stat.information" v-tooltip="stat.information" icon='fal fa-info-circle' class='cursor-pointer text-sm' fixed-width aria-hidden='true' />
                </p>
                <p class="mt-2 flex items-baseline gap-x-2 tabular-nums">
                    <span class="text-4xl font-semibold tracking-tight">{{ stat.value }}</span>
                    <span v-if="stat.unit" class="">{{ stat.unit }}</span>
                </p>
            </div>
        </div>

        <div class="-mt-4 row-start-1 md:row-start-auto pb-1 justify-self-end flex justify-end w-full md:w-96">
            <Fieldset legend="Ringkasan users" class="h-fit w-full">
                <Chart type="pie" :data="stats_pie" :options="chartOptions" class="h-80 w-fit mx-auto md:h-auto md:mx-0 md:w-full" />
            </Fieldset>
        </div>
    </div>
</template>